module.exports = __webpack_public_path__ + "static/media/bhs_icon_hassle_free.bc53a1c8.png";